export default __webpack_public_path__ + "static/media/007-star-green.c9e0cffe.svg";